import { message } from 'antd';

/**
 * Copies text to the clipboard and displays a notification.
 *
 * @param {string} text - The text to be copied to the clipboard.
 */
const copyClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        message.success('Copied to clipboard!');
    } catch (error) {
        message.error('Failed to copy to clipboard.');
    }
};

export default copyClipboard;
